import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaUniversity,
  FaUserGraduate,
  FaCalendarAlt,
  FaLaptopCode,
} from "react-icons/fa";
import Footer from "./Footer";

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    qualification: "",
    college: "",
    otherCollege: "",
    degreeCompleted: "",
    completionYear: "",
    internshipType: "",
    startDate: "",
    endDate: "",
  });

  const degreeOptions = [
    "B.Tech", "M.Tech", "BCA", "MCA", "B.Sc", "M.Sc", "BBA", "MBA", "Diploma", "Other"
  ];

  const collegeOptions = [
    "IIT", "NIT", "IIIT", "Private College", "Government College", "Other"
  ];

  const internshipOptions = [
    "Backend", "Frontend", "Fullstack", "DevOps", "Data Analyst", "Cloud Server"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      to_email: "ishansharma199811@gmail.com",
      ...formData,
    };

    emailjs
      .send("service_grik1tt", "YOUR_TEMPLATE_ID", templateParams, "YOUR_USER_ID")
      .then(() => {
        alert("Form submitted and email sent successfully!");
        setFormData({
          name: "", email: "", mobile: "", qualification: "",
          college: "", otherCollege: "", degreeCompleted: "",
          completionYear: "", internshipType: "", startDate: "", endDate: "",
        });
      })
      .catch((err) => {
        console.error("EmailJS error", err);
        alert("Failed to send form. Please try again.");
      });
  };

  // Inject keyframes into <style>
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes rotateSun {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      @keyframes moveStars {
        from { transform: translate3d(0, 0, 0) scale(1); }
        to { transform: translate3d(-1000px, 1000px, 0) scale(1.2); }
      }
      @keyframes gradient {
        0% {background-position: 0% 50%;}
        50% {background-position: 100% 50%;}
        100% {background-position: 0% 50%;}
      }
    `;
    document.head.appendChild(style);
  }, []);

  const styles = {
    backgroundWrapper: {
      position: "fixed",
      top: 0, left: 0, width: "100%", height: "100%",
      background: "radial-gradient(ellipse at bottom, #050505 0%, #000000 100%)",
      zIndex: -1,
      overflow: "hidden",
      perspective: "1000px"
    },
    stars: {
        width: "2000px",
        height: "2000px",
        backgroundImage: "url('contact.gif')",
        backgroundRepeat: "repeat",
        animation: "moveStars 300s linear infinite",
        position: "absolute",
        top: "-500px",
        left: "-500px",
        opacity: 0.4,
      },
      
    sun: {
      position: "absolute",
      top: "20%", left: "50%",
      width: "180px", height: "180px",
      marginLeft: "-90px",
      background: "radial-gradient(circle, #FFD700 0%, #FF8C00 80%, transparent 100%)",
      borderRadius: "50%",
      boxShadow: "0 0 60px 20px #FF8C00",
      animation: "rotateSun 20s linear infinite",
      filter: "blur(0.5px)"
    },
    formWrapper: {
      maxWidth: "600px",
      margin: "50px auto",
      padding: "30px",
      borderRadius: "20px",
      backgroundColor: "rgba(255,255,255,0.95)",
      boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
      position: "relative",
      zIndex: 10
    },
    label: {
      fontWeight: "600",
      marginTop: "15px",
      display: "block",
      color: "#333",
      fontSize: "15px"
    },
    input: {
      width: "100%",
      padding: "10px",
      marginTop: "5px",
      marginBottom: "10px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px"
    },
    radioWrapper: {
      display: "flex",
      gap: "20px",
      marginTop: "8px",
      fontSize: "14px"
    },
    button: {
      padding: "12px 25px",
      backgroundColor: "#4A90E2",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "16px",
      cursor: "pointer",
      marginTop: "20px",
      boxShadow: "0 3px 10px rgba(0,0,0,0.1)"
    }
  };

  return (
    <>
      <div style={styles.backgroundWrapper}>
        <div style={styles.stars}></div>
        <motion.div style={styles.sun} animate={{ rotate: 90 }} transition={{ repeat: Infinity, duration: 60, ease: "linear" }} />
      </div>

      <motion.div style={{ textAlign: "center", marginTop: "60px" }}>
        <div
          style={{
            transform: "rotate(360deg)",
            display: "inline-block",
            fontSize: "48px",
            color: "orange",
            marginBottom: "-20px"
          }}
        >
          ꗃɈ
        </div>
        <div
          style={{
            fontSize: "36px",
            fontWeight: "700",
            letterSpacing: "5px",
            fontFamily: "'Poppins', sans-serif",
            background: "linear-gradient(45deg, #2c3e50, #8e44ad, #2980b9, #16a085)",
            backgroundSize: "400% 400%",
            WebkitBackgroundClip: "text",
            color: "transparent",
            animation: "gradient 10s ease infinite",
          }}
        >
          Girraj Technology
        </div>
      </motion.div>

      <form onSubmit={handleSubmit} style={styles.formWrapper}>
        <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>
          Internship Enquiry Form
        </h2>

        <label style={styles.label}><FaUser /> Name</label>
        <input name="name" value={formData.name} onChange={handleChange} style={styles.input} required />

        <label style={styles.label}><FaEnvelope /> Email</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} style={styles.input} required />

        <label style={styles.label}><FaPhone /> Mobile</label>
        <input name="mobile" value={formData.mobile} onChange={handleChange} style={styles.input} required />

        <label style={styles.label}><FaUserGraduate /> Qualification</label>
        <select name="qualification" value={formData.qualification} onChange={handleChange} style={styles.input} required>
          <option value="">Select Degree</option>
          {degreeOptions.map((deg, i) => <option key={i} value={deg}>{deg}</option>)}
        </select>

        <label style={styles.label}><FaUniversity /> College</label>
        <select name="college" value={formData.college} onChange={handleChange} style={styles.input} required>
          <option value="">Select College</option>
          {collegeOptions.map((col, i) => <option key={i} value={col}>{col}</option>)}
        </select>

        {formData.college === "Other" && (
          <input name="otherCollege" value={formData.otherCollege} onChange={handleChange} placeholder="Enter college name" style={styles.input} />
        )}

        <label style={styles.label}><FaUserGraduate /> Degree Completed?</label>
        <div style={styles.radioWrapper}>
          <label><input type="radio" name="degreeCompleted" value="yes" checked={formData.degreeCompleted === "yes"} onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="degreeCompleted" value="no" checked={formData.degreeCompleted === "no"} onChange={handleChange} /> No</label>
        </div>

        {formData.degreeCompleted === "no" && (
          <>
            <label style={styles.label}><FaCalendarAlt /> Expected Completion Year</label>
            <input type="number" name="completionYear" value={formData.completionYear} onChange={handleChange} style={styles.input} />
          </>
        )}

        <label style={styles.label}><FaLaptopCode /> Internship Type</label>
        <select name="internshipType" value={formData.internshipType} onChange={handleChange} style={styles.input} required>
          <option value="">Select Internship Type</option>
          {internshipOptions.map((type, i) => <option key={i} value={type}>{type}</option>)}
        </select>

        <label style={styles.label}><FaCalendarAlt /> Start Date</label>
        <input type="date" name="startDate" value={formData.startDate} onChange={handleChange} style={styles.input} required />

        <label style={styles.label}><FaCalendarAlt /> End Date</label>
        <input type="date" name="endDate" value={formData.endDate} onChange={handleChange} style={styles.input} required />

        <button type="submit" style={styles.button}>Submit</button>
      </form>
      <br /><br /><br /><br />
      <Footer />
    </>
  );
};

export default EnquiryForm;
